export default function advancedActivities({ next, router }) {
    if (localStorage.getItem('activities-framework-type') !== 'basic') {
        return router.push({ name: 'unauthorised' });
    }

    return next();
}
